import { APISessionError } from '../../helpers/Session';
import { SharedBox } from '../../types/SharedBox';
import API from '../api';

export const SharedBoxAPI = {
    getSharedBox: async () => {
        try {
            const res = await API.get('/api/v1/external/sharedbox');
            const resData = res.data;
            return resData.data as SharedBox;
        } catch (e: any) {
            APISessionError(e);
            throw e;
        }
    },
    postMessage: async (body: any) => {
        try {
            const res = await API.post('/api/v1/external/sharedbox/message', body);
            const resData = res.data;
            return resData.data as SharedBox;
        } catch (e: any) {
            APISessionError(e);
            throw e;
        }
    },
    postMessageWithAttachments: async (formData: FormData) => {
        try {
            const res = await API.post('/api/v1/external/sharedbox/message/form', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            const resData = res.data;
            return resData.data as SharedBox;
        } catch (e: any) {
            APISessionError(e);
            throw e;
        }
    }
};

export default SharedBoxAPI;